import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

/**
 * /walk accepts Google UTM query parameters (and short aliases) then redirects to /.
 *
 * | Dimension | Query param(s)        |
 * |-----------|------------------------|
 * | Campaign  | utm_campaign, campaign |
 * | Source    | utm_source, source     |
 * | Medium    | utm_medium, medium     |
 * | Content   | utm_content, content   |
 * | Term      | utm_term, term         |
 *
 * Example:
 * /walk?utm_source=newsletter&utm_medium=email&utm_campaign=spring2025&utm_content=hero&utm_term=will
 */
@Component({
  selector: 'app-walk-redirect',
  template: `<p>Redirecting...</p>`
})
export class WalkRedirectComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cookieService: CookieService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const utm = this.resolveUtm(params);

      const trackingData = {
        utm_campaign: utm.utm_campaign,
        utm_source: utm.utm_source,
        utm_medium: utm.utm_medium,
        utm_content: utm.utm_content,
        utm_term: utm.utm_term,
        landing_page: '/walk',
        timestamp: new Date().toISOString()
      };

      this.cookieService.set('cl_tracking', JSON.stringify(trackingData), 60, '/');

      setTimeout(() => {
        this.router.navigate(['/']);
      }, 100);
    });
  }

  private resolveUtm(params: Params): {
    utm_campaign: string;
    utm_source: string;
    utm_medium: string;
    utm_content: string;
    utm_term: string;
  } {
    const first = (...keys: string[]) => {
      for (const k of keys) {
        const v = params[k];
        if (v != null && String(v).trim() !== '') {
          return String(v).trim();
        }
      }
      return '';
    };

    return {
      utm_campaign: first('utm_campaign', 'campaign'),
      utm_source: first('utm_source', 'source') || 'direct',
      utm_medium: first('utm_medium', 'medium'),
      utm_content: first('utm_content', 'content'),
      utm_term: first('utm_term', 'term')
    };
  }

}